import { connect } from 'react-redux'
import { setQuickSpin, message } from '../../redux/actions'
import Component from '../component'

/**
 * A prompt to enable or disable the Quickspin feature.
 */
@connect(state => ({ base: state.base }), { setQuickSpin, message })
export default class QuickSpinPrompt extends Component {
  /**
   * Enables or disables Quickspin feature, and closes the prompt.
   * @param {boolean} quickspin - "Yes" or "No".
   * @param {object} e - Button event object.
   * @returns {boolean}
   */
  setQuickspin = (quickspin, e) => {
    e.preventDefault()
    e.stopPropagation()

    this.props.setQuickSpin(quickspin)
    this.props.message(null)

    return false
  }

  /**
   * Renders out a DOM element, with a yes or no question.
   * @returns {*}
   */
  render() {
    return (
      <div className="popup-content">
        <div className="popup-message">
          {this.t('quickspinPrompt.message')}
        </div>

        <br />

        <div className="buttonContainer two-col">
          <button onClick={e => { this.setQuickspin(false, e) }}>
            { this.t('quickspinPrompt.disableQuickspin')}
          </button>
          <button onClick={e => { this.setQuickspin(true, e) }}>
            {this.t('quickspinPrompt.enableQuickspin')}
          </button>
        </div>
      </div>
    )
  }
}
